<template>
    <el-drawer title="优惠券快照" :visible.sync="visible" :wrapperClosable="false" size="auto" append-to-body @closed="closed">
        <div class="drawer-content" v-loading="dataLoading">
            <el-alert type="warning" :closable="false"><div slot="title">以下显示的是用户领取优惠券时的优惠券快照信息</div></el-alert>
            <table v-if="objData" class="info-table MT20" width="100%">
                <tr>
                    <th>优惠券名称</th><td>{{objData.couponName}}</td>
                </tr>
                <tr>
                    <th>有效期</th><td>{{objData.beginTime}}  至 {{objData.endTime}}</td>
                </tr>
                <tr>
                    <th>优惠金额</th><td>{{objData.couponPrice}}元</td>
                </tr>
                <tr>
                    <th>满减金额</th><td>{{objData.couponSubtractPrice}}元</td>
                </tr>
                <tr>
                    <th>使用终端</th>
                    <td>
                        <span v-if="objData.useTerminal === 0">全平台</span>
                        <span v-else-if="objData.useTerminal === 1">WEB</span>
                        <span v-else-if="objData.useTerminal === 2">WAP</span>
                        <span v-else-if="objData.useTerminal === 3">APP</span>
                    </td>
                </tr>
                <tr>
                    <th>备注</th><td>{{objData.description}}</td>
                </tr>
                <tr>
                    <th>业务范围</th><td>{{category[objData.category]}}</td>
                </tr>
                <tr v-if="objData.activityIds">
                    <th>演出限制</th><td>{{objData.activityIds}}</td>
                </tr>
                <tr v-if="objData.couponActivityTickets && objData.couponActivityTickets.length > 0">
                    <th>限制票品</th>
                    <td>
                        <div v-for="(item,index) in objData.couponActivityTickets" :key="index" class="list">{{index + 1}}、{{item}}</div>
                    </td>
                </tr>
                <tr v-if="objData.raiseIds">
                    <th>众筹限制</th><td>{{objData.raiseIds}}</td>
                </tr>
                <tr v-if="objData.subsidyStr">
                    <th>承担方</th><td>{{objData.subsidyStr}}</td>
                </tr>
                <tr v-if="objData.goodsIds">
                    <th>周边限制</th><td>{{objData.goodsIds}}</td>
                </tr>
            </table>
        </div>
        <div class="drawer-footer">
            <el-button @click="visible = false">关 闭</el-button>
        </div>
    </el-drawer>
</template>

<script>
export default {
    data() {
        return {
            visible: false,
            id: '',
            objData: null,
            dataLoading: false,
            category:{
                1: '演出',
                2: '众筹',
                3: '周边',
                4: '演出/众筹',
                5: '演出/周边',
                6: '演出/众筹/周边',
                7: '众筹/周边'
            }
        };
    },
    methods: {
        show(id) {
            this.id = id;
            this.getData();
            this.visible = true;
        },
        closed() {
            this.objData = null;
            this.visible = false;
        },
        getData() {
            this.dataLoading = true;
            this.$request({
                url: '/coupon/use/coupon/snapshot',
                method: 'POST',
                params: {
                    id: this.id
                }
            })
                .then(res => {
                    const {state, msg, result} = res.data;
                    if (state == 1 && result) {
                        this.objData = result;
                    } else {
                        this.$message.error(msg || '请求失败');
                    }
                })
                .catch(() => {
                    this.$message.error('请求错误');
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped>
.list{
    line-height: 28px;
}
</style>